<template>
  <v-radio-group
    v-model="selectedDifficultyId"
    hide-details
    row>
    <v-radio
      v-for="(difficulty, index) in difficulties"
      :key="index"
      :label="difficulty.name"
      :value="difficulty.id"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import teacher from '../../mixins/teacher';

export default {
  mixins: [teacher],

  computed: {
    difficulties() {
      return this.$store.state.master.allDifficulties
    },
    selectedDifficultyId: {
      get() {
        return this.currentSubjectCondition.selectedDifficulty?.id
      },
      set(value) {
        this.$store.commit(
          'changeCurrentSubjectCondition',
          { selectedDifficulty: this.difficulties.find(difficulty => { return value === difficulty.id }) }
        )
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
  .v-label
    font-weight bold
</style>
